var map = {
  "./": "65161",
  "./add": "53938",
  "./add.js": "53938",
  "./destroy": "61475",
  "./destroy.js": "61475",
  "./details": "52063",
  "./details.js": "52063",
  "./edit": "42809",
  "./edit.js": "42809",
  "./index": "65161",
  "./index.js": "65161"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 75455;
